import { KeyValue } from "@/main/models/common";

export enum VoucherRefundStatusTypes {
	GET_VOUCHER_REFUND_STATUS = "@voucherRefundStatus/GET_VOUCHER_REFUND_STATUS",
	SAVE_VOUCHER_REFUND_STATUS = "@voucherRefundStatus/SAVE_VOUCHER_REFUND_STATUS",
	RESET_REDUCER_VOUCHER_REFUND_STATUS = "@voucherRefundStatus/RESET_REDUCER_VOUCHER_REFUND_STATUS",
}

export interface VoucherRefundStatusState {
	readonly voucherRefundStatus: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetVoucherRefundStatus {
	type: typeof VoucherRefundStatusTypes.GET_VOUCHER_REFUND_STATUS;
}

export interface SaveVoucherRefundStatus {
	type: typeof VoucherRefundStatusTypes.SAVE_VOUCHER_REFUND_STATUS;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerVoucherRefundStatus {
	type: typeof VoucherRefundStatusTypes.RESET_REDUCER_VOUCHER_REFUND_STATUS;
}

export type VoucherRefundStatusActionTypes =
	| GetVoucherRefundStatus
	| SaveVoucherRefundStatus
	| ResetReducerVoucherRefundStatus;
